import { Bot, Clapperboard, ImageIcon, Send, type LucideIcon } from 'lucide-react'

const ROLE_ICONS: Record<string, LucideIcon> = {
  image_producer: ImageIcon,
  video_producer: Clapperboard,
  outreach: Send,
}

/** The icon a team member shows in the agent list and its chat, by its role's slug. */
export function roleIcon(slug: string): LucideIcon {
  return ROLE_ICONS[slug] ?? Bot
}
